import axios from "../../../../utils/request";

function GET_LIST(params) {
  return axios.get("/translation/BatchTranslation/customerTokenList", {
    params: params
  });
}

function GET_NAME(params) {
  return axios.get("/translation/BatchTranslation/customerList", {
    params: params
  });
}
export default {
  GET_LIST,
  GET_NAME
};
